module.exports = __webpack_public_path__ + "static/media/grip-lines.a2dde18d.svg";